// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'weui';
import Print from 'vue-print-nb'
import axios from 'axios'
// import qs from 'qs';
import './utils/request.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'weui/dist/style/weui.min.css';
import store from '@/store/index'
import filterRouter from "@/utils/filterRouter";
import getBtnRole from "@/utils/getBtnRole";
import {
  setCookie,
  getCookie,
  delCookie
} from '@/utils/cookies.js'
import '@/style/base.scss'
import '@/style/iconfont/iconfont.css'
import moment from 'moment'
import echarts from 'echarts'
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}
Vue.use(ElementUI);
Vue.use(Print)
// 把axios挂载到vue原型中
Vue.prototype.$axios = axios
// 更换测试服的接口// //带test为测试服
Vue.prototype.$api = '/api'
/////////////////////
// Vue.prototype.$ipConfig = '120.79.169.222' ////测试
Vue.prototype.$ipConfig = '39.108.227.167' ////正式
//更换防伪和物流发码地址
Vue.prototype.$scanout = 'market'
////////////////////// //带test为测试服
Vue.prototype.$echarts = echarts
Vue.prototype.$copyText = function (text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
}

Vue.config.productionTip = false
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD') {
  return moment(dataStr).format(pattern)
})

if (localStorage.userRouter) {
  let data = JSON.parse(localStorage.userRouter);
  if (data) {
    //这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
    let routers = [];
    let btnRloe = []
    filterRouter(routers, data);
    getBtnRole(btnRloe, data)
    store.commit("setBtnRole", btnRloe);
    router.options.routes = routers;
    router.addRoutes(routers);
  }
}
Vue.directive('has', {
  inserted: function (el, binding) {
    if (!permissionJudge(binding.value)) {
      el.parentNode.removeChild(el)
    }
    function permissionJudge(val) {
      let userBtn = JSON.parse(localStorage.btnList)
      let flag = false
      userBtn.forEach(item => {
        if (item == val) {
          return flag = true
        }
      });
      return flag
    }
  },
})
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js